export default __webpack_public_path__ + "static/media/close-hover.9b40d2d0.png";